"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ModalFramePortal = _interopRequireDefault(require("./ModalFramePortal"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  z-index: 9999999;\n  top: ", "px;\n  display: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ModalFrameFrame = _styledComponents.default.iframe.withConfig({
  displayName: "ModalFrame__ModalFrameFrame",
  componentId: "sc-1hqh2db-0"
})(_templateObject(), function (_ref) {
  var scrollY = _ref.scrollY;
  return scrollY;
}, function (_ref2) {
  var showModal = _ref2.showModal;
  return showModal ? null : 'none';
});

var ModalFrame =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ModalFrame, _React$Component);

  function ModalFrame() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ModalFrame);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ModalFrame)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      scrollY: window.scrollY
    };

    _this.setModalRef = function (node) {
      _this.modalRef = node;
    };

    _this.handlePostMessage = function (event) {
      if (_this.modalRef.contentWindow === event.source && event.data === 'MODAL_READY') {
        _this.props.setModalReady(true);
      }

      if (_this.modalRef.contentWindow === event.source && event.data === 'CLOSE_MODAL') {
        _this.props.setShowModal(false);
      }

      if (_this.modalRef.contentWindow === event.source && event.data === 'MODAL_ERROR') {
        _this.props.setShowModal(false);

        _this.props.setLoadModal(false);
      }
    };

    _this.handleScrollChange = function () {
      _this.setState({
        scrollY: window.scrollY
      });
    };

    return _this;
  }

  (0, _createClass2.default)(ModalFrame, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      try {
        document.domain = document.domain;
      } catch (e) {
        console.log(e);
      }

      window.addEventListener('message', this.handlePostMessage);
      window.addEventListener('scroll', this.handleScrollChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handlePostMessage);
      window.removeEventListener('scroll', this.handleScrollChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          modalReady = _this$props.modalReady,
          showModal = _this$props.showModal,
          frameProps = _this$props.frameProps,
          src = _this$props.src,
          id = _this$props.id;
      var scrollY = this.state.scrollY;
      return _react.default.createElement(_ModalFramePortal.default, null, _react.default.createElement(ModalFrameFrame, {
        id: id,
        src: src,
        height: "100%",
        width: "100%",
        frameBorder: "0",
        showModal: modalReady && showModal,
        scrollY: scrollY,
        innerRef: function innerRef(node) {
          _this2.setModalRef(node);
        },
        "data-props": JSON.stringify(frameProps)
      }));
    }
  }]);
  return ModalFrame;
}(_react.default.Component);

var _default = ModalFrame;
exports.default = _default;
module.exports = exports.default;